/**
 * Индикатор статуса данных фьючерсов (Live / Historical / Closed)
 * ЗАЧЕМ: Показывает пользователю статус подключения к данным фьючерсов через Databento
 * Затрагивает: TopNav, отображение статуса Databento API
 */

import React from 'react';
import './LiveDataIndicator.css';
import massiveLogo from '../db.png';
import useMarketStatus from '../hooks/useMarketStatus';

const FuturesDataIndicator = () => {
  const { status, loading } = useMarketStatus();

  // Состояние загрузки
  if (loading) {
    return (
      <div className="live-indicator loading">
        <div className="indicator-logo-wrapper">
          <img src={massiveLogo} alt="Databento" className="indicator-logo" />
        </div>
        <span className="indicator-text">Проверка...</span>
      </div>
    );
  }

  // Если нет данных, не показываем индикатор
  if (!status) {
    return null;
  }

  // Определение CSS класса на основе статуса
  const getIndicatorClass = () => {
    const mode = status.market_mode;
    
    // Live торги
    if (mode === 'live') {
      return 'live';
    }
    // Pre-market, After-hours
    else if (mode === 'pre_open' || mode === 'after_hours') {
      return 'delayed';
    }
    // Перерыв в торгах
    else if (mode === 'break') {
      return 'delayed';
    }
    // Рынок закрыт (weekend, holiday, historical)
    else if (mode === 'historical' || mode === 'holiday') {
      return 'offline';
    }
    // По умолчанию offline
    else {
      return 'offline';
    }
  };

  // Текст индикатора
  const getIndicatorText = () => {
    const mode = status.market_mode;
    
    if (mode === 'live') {
      return 'Фьючерсы: LIVE';
    } else if (mode === 'pre_open') {
      return 'Фьючерсы: Pre-market';
    } else if (mode === 'after_hours') {
      return 'Фьючерсы: After-hours';
    } else if (mode === 'break') {
      return 'Фьючерсы: Break';
    } else if (mode === 'historical') {
      return 'Фьючерсы: Closed';
    } else if (mode === 'holiday') {
      return 'Фьючерсы: Holiday';
    } else {
      return 'Фьючерсы: Offline';
    }
  };

  // Текст тултипа при наведении
  const getTooltipText = () => {
    const mode = status.market_mode;
    
    if (mode === 'live') {
      const sessionType = status.session_info?.session_type || 'regular';
      return `Live торги фьючерсами (${sessionType} session)`;
    } else if (mode === 'pre_open') {
      return 'Pre-market торги';
    } else if (mode === 'after_hours') {
      return 'After-hours торги';
    } else if (mode === 'break') {
      const nextSession = status.next_session_start;
      return `Перерыв в торгах. Следующая сессия: ${nextSession || 'не определена'}`;
    } else if (mode === 'historical') {
      return 'Рынок закрыт (исторические данные)';
    } else if (mode === 'holiday') {
      return 'Праздник — рынок закрыт';
    } else {
      return 'Статус рынка неизвестен';
    }
  };

  return (
    <div 
      className={`live-indicator ${getIndicatorClass()}`}
      title={getTooltipText()}
    >
      <div className="indicator-logo-wrapper">
        <img 
          src={massiveLogo} 
          alt="Databento" 
          className="indicator-logo"
        />
      </div>
      <span className="indicator-text">{getIndicatorText()}</span>
    </div>
  );
};

export default FuturesDataIndicator;
